// The pinned-condition strip under the Layout Canvas toolbar: up to nine conditions one click — or one key, 1–9 —
// away. Pin from the Conditions dock (📌) or the Ctrl+K palette. The strip is a per-viewer preference; arming a
// pinned condition does exactly what picking it in the Conditions dock does.

export default function ConditionStrip({ resolved, armedKey, onArm, onUnpin, locked }) {
  return (
    <div data-testid="condition-strip" style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", margin: "0 0 8px", padding: "4px 8px", border: "1px solid var(--cs-border)", borderRadius: 8, background: "var(--surface2, var(--surface))", fontSize: 12 }}>
      <span style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, color: "var(--text3)" }}>Pinned</span>
      {resolved.length === 0 && (
        <span style={{ color: "var(--text3)" }}>Pin the conditions you use most (📌 in the Conditions dock, or Ctrl+K) — then press 1–9 to arm them.</span>
      )}
      {resolved.map(({ digit, type }) => {
        const armed = armedKey === type.TypeKey;
        return (
          <span key={type.TypeKey} style={{ display: "inline-flex", alignItems: "stretch", border: `1px solid ${armed ? "var(--cs-blue)" : "var(--cs-border)"}`, borderRadius: 6, overflow: "hidden", background: armed ? "rgba(37,99,235,0.12)" : "var(--surface)" }}>
            <button
              type="button"
              onClick={() => onArm(type)}
              disabled={locked}
              title={`${type.Name || type.Code} — press ${digit} to arm${locked ? " (read-only revision)" : ""}`}
              aria-pressed={armed}
              aria-label={`Arm ${type.Code || type.Name} (key ${digit})`}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "3px 8px", border: "none", background: "none", cursor: locked ? "not-allowed" : "pointer", fontSize: 12, fontWeight: 600, color: "var(--text)", opacity: locked ? 0.5 : 1 }}
            >
              <kbd style={{ fontSize: 10, padding: "0 5px", border: "1px solid var(--cs-border)", borderRadius: 3, color: "var(--text3)" }}>{digit}</kbd>
              {type.Color && <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: 2, background: type.Color, border: "1px solid var(--cs-border)" }} />}
              <span>{type.Code || type.Name}</span>
            </button>
            <button type="button" onClick={() => onUnpin(type.TypeKey)} title="Unpin" aria-label={`Unpin ${type.Code || type.Name}`}
              style={{ border: "none", borderLeft: "1px solid var(--cs-border)", background: "none", cursor: "pointer", fontSize: 11, color: "var(--text3)", padding: "0 6px" }}>✕</button>
          </span>
        );
      })}
    </div>
  );
}
